import React from 'react';
import { Container } from 'react-bootstrap';
import JpoLogo from '../../assets/images/jpoLogo.jpg';

/**
 * ヘッダーコンポーネントです。
 * @returns {JSX.Element} - JSX要素
 */
const Header: React.FC = () => {
  return (
    <header className="py-3">
      <Container className="d-flex align-items-center">
        <img className="rounded-circle d-inline" src={JpoLogo} alt="logo" width="70" height="70" />
        <div className="d-inline-block ms-3">
          <h1 className="h6 text-white">電子特殊申請書類作成支援ツール</h1>
          <h2 className="h2 text-white">自動納付申出書／取下書</h2>
        </div>
      </Container>
    </header>
  );
}

export default Header;